module.exports = __webpack_public_path__ + "static/img/80.46f8248.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/26/80.jpg
// module id = 754
// module chunks = 0